import { useSelector } from 'react-redux';

import { getIsDistanceCalculatingEnabled } from '../../../../../selectors/distanceCalculating';
import { selectRegularInfrastructure } from '../../../../../selectors/infrastructure';
import { getIsTransportAccessibilityServiceAvailable } from '../../../../../selectors/mapServices';
import { EMapService } from '../../../../../types/map';
import { hasFutureObjects } from '../../../../../utils/map';

export const useMapServices = () => {
  const regularInfrastructure = useSelector(selectRegularInfrastructure);

  const isFutureInfrastructureServiceAvailable = hasFutureObjects(regularInfrastructure);
  const isTransportAccessibilityServiceAvailable = useSelector(getIsTransportAccessibilityServiceAvailable);
  const isRouteServiceAvailable = useSelector(getIsDistanceCalculatingEnabled);

  const services: EMapService[] = [];

  if (isFutureInfrastructureServiceAvailable) {
    services.push(EMapService.FutureInfrastructure);
  }

  if (isTransportAccessibilityServiceAvailable) {
    services.push(EMapService.TransportAccessibility);
  }

  if (isRouteServiceAvailable) {
    services.push(EMapService.Routes);
  }

  return services;
};
